﻿import {postData, debounce} from "./utils";


$(function () {
    $.HeaderSearch = {
        // Configuration
        config: {
            debounceWait: 300,
            minSearchLength: 3,
            searchEndpoint: "/search/predict",
        },

        // Selectors
        selectors: {
            input: '.js-header-search-input',
            contextSelect: '.js-search-context-select',
            contextItem: '.js-search-context-item',
            contextClear: '.search-context__name',
            clearButton: '.header-search__clear-icon',
            results: '.js-search-results',
            headerSearch: '.js-header-search',
            overlay: '.js-header-search-overlay',
            searchSubmit: '.js-submit-search',
        },

        // CSS Classes
        classes: {
            expanded: 'header-search--expanded',
            contextActive: 'search-context__item--active',
            resultsActive: 'header-search--results-showed',
            contextShowed: 'header-search--context-showed',
        },

        // State
        state: {
            searchContext: null,
            currentSearchTerm: '',
            isSearching: false,
            searchAbortController: null,
        },

        init() {
            this.initializeState();
            this.setEvents();
            this.debouncedSearch = debounce(this.performSearch.bind(this), this.config.debounceWait);
        },

        initializeState() {
            const url = new URL(window.location.href);
            const id = url.searchParams.get('mode');
            const query = url.searchParams.get('q');

            this.setSearchContext(id);
            this.setSearchQuery(query);
        },

        async performSearch(term) {
            if (this.state.isSearching) {
                // Cancel previous search if it's still in progress
                this.state.searchAbortController?.abort();
            }

            // Create new abort controller for this search
            this.state.searchAbortController = new AbortController();
            this.state.isSearching = true;

            try {
                if (!term || term.length < this.config.minSearchLength) {
                    this.clearResults(false);
                    return;
                }

                const data = await postData(
                    this.config.searchEndpoint,
                    {
                        term: term,
                        searchContext: this.state.searchContext
                    },
                    {
                        signal: this.state.searchAbortController.signal
                    }
                );

                // Verify the search term hasn't changed during the request
                if (term === $(this.selectors.input).val().trim()) {
                    
                }

                $(this.selectors.results).html(data);
                this.showSearchResults();
                
            } catch (error) {
                if (error.name === 'AbortError') {
                    console.log('Search aborted');
                } else {
                    console.error('Search error:', error);
                }
            } finally {
                this.state.isSearching = false;
            }
        },

        setSearchContext(id) {
            this.state.searchContext = id || null;

            if (!id) {
                this.clearSearchContext();
                return;
            }

            const contextItem = $(`${this.selectors.contextItem}[data-search-context-id=${id}]`);
            if (contextItem.length) {
                const name = contextItem.data('searchContextName');
                $(this.selectors.contextSelect).text(name);
            } else {
                this.clearSearchContext();
            }
        },

        setSearchQuery(query) {
            if (query) {
                $(this.selectors.input).val(query);
            }
        },

        clearSearchContext() {
            this.state.searchContext = null;
            $(this.selectors.contextSelect).text('Искать везде');
        },

        showSearchResults() {
            $(this.selectors.headerSearch).addClass(this.classes.resultsActive);
            addBlur();
        },

        clearResults(clearInputField = true) {
            if (clearInputField) {
                $(this.selectors.input).val('');
            }

            $(this.selectors.headerSearch)
                .removeClass(`${this.classes.resultsActive} ${this.classes.contextShowed}`);

            this.resetExpandedSearch();
        },

        resetExpandedSearch() {
            $(this.selectors.headerSearch).removeClass(this.classes.expanded);
            removeBlur();
        },

        toggleSearchContextDropdown() {
            addBlur();
            $(this.selectors.headerSearch)
                .removeClass(this.classes.resultsActive)
                .toggleClass(this.classes.contextShowed);
        },

        handleSearchSubmit(term) {
            const url = new URL('/catalog/search/', window.location.origin);
            url.searchParams.set('q', term);
            url.searchParams.set('r_0', "0-2147483647");

            if (this.state.searchContext != null) {
                url.searchParams.set('mode', this.state.searchContext);
            }

            window.location.href = url;
        },

        setEvents() {
            const self = this;

            // Search input handler with sanitization
            $B.on('keyup change', this.selectors.input, function (e) {
                const term = $(this).val().trim();

                // Handle enter key
                if (e.keyCode === 13 || e.which === 13 || e.key === 'Enter') {
                    self.handleSearchSubmit(term);
                    return;
                }

                // Trigger debounced search
                self.debouncedSearch(term);
            });

            // Clear results
            $B.on('click', this.selectors.clearButton, () => {
                this.clearResults();
            });

            // Close on overlay click
            $B.on('click', this.selectors.overlay, () => {
                this.clearResults(false);
            });

            // Context select
            $B.on('click', this.selectors.contextSelect, () => {
                this.toggleSearchContextDropdown();
            });

            // Context item selection
            $B.on('click', this.selectors.contextItem, function () {
                self.clearResults(false);
                const id = $(this).data('searchContextId');
                self.setSearchContext(id);
                $(self.selectors.input).first().change();
            });

            // Clear context
            $B.on('click', this.selectors.contextClear, () => {
                this.clearResults(false);
                this.setSearchContext(null);
            });
        }
    };

    $.HeaderSearch.init();
});